// extracted by mini-css-extract-plugin
module.exports = {"vWhite2":"#fafafa","item":"ReportsFreedomIncomeListItem_item__3ZQ1C","body":"ReportsFreedomIncomeListItem_body__y1_jY"};